import { GroupedReaction, ReactionInitiator } from 'features/chat/types';

export function computeReactions(
  current: GroupedReaction[],
  emoji: string,
  initiator: ReactionInitiator,
  added: boolean,
  local: boolean
): GroupedReaction[] {
  if (added) {
    const existing = current.find((r) => r.emoji === emoji);
    if (existing) {
      if (existing.initiators.some((i) => i.id === initiator.id)) {
        return current;
      }
      return current.map((r) =>
        r.emoji === emoji
          ? {
              ...r,
              initiators: [...r.initiators, initiator],
              localUserReacted: local ? true : r.localUserReacted,
            }
          : r
      );
    }
    return [...current, { emoji, initiators: [initiator], localUserReacted: local }];
  }

  const existing = current.find((r) => r.emoji === emoji);
  if (!existing) {
    return current;
  }

  const updatedInitiators = existing.initiators.filter((i) => i.id !== initiator.id);
  if (updatedInitiators.length === 0) {
    return current.filter((r) => r.emoji !== emoji);
  }

  return current.map((r) =>
    r.emoji === emoji
      ? {
          ...r,
          initiators: updatedInitiators,
          localUserReacted: local ? false : r.localUserReacted,
        }
      : r
  );
}
